import { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Divider,
  Collapse,
  Button,
} from "@mui/material";

const CompanyPortfolio = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box
      sx={{
        width: "100%",
        // backgroundColor: "#fff",
        color: "#222",
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth={false}>
        {/* Main Heading */}
        <Typography
          component="h1"
          sx={{
            fontSize: { xs: "2rem", md: "2.8rem" },
            fontWeight: 700,
            color: "#0b2a5b",
            mb: 2,
          }}
        >
          Gift Cards UAE
        </Typography>

        <Typography
          sx={{
            fontSize: "1.25rem",
            lineHeight: 1.8,
            color: "#555",
            mb: 5,
          }}
        >
          Looking for the right gift in the UAE? 99gift.ae makes it easy to
          explore gift cards from popular brands across shopping, gaming,
          fashion, entertainment, footwear and more. Choose from available gift
          card values and find an option that suits your occasion, budget or
          recipient.
        </Typography>

        <Divider sx={{ mb: 5 }} />

        {/* Section 1 */}
        <Box sx={{ mb: 5 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 700,
              color: "#0b2a5b",
              mb: 2,
            }}
          >
            Buy Gift Cards in the UAE– Shop Digital Gift Cards Online
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.25rem", md: "1.25rem" },
              color: "#555",
              lineHeight: 1.8,
              mb: 2,
            }}
          >
            Finding the right gift does not always have to be complicated. With
            99gift.ae, you can explore a wide selection of gift cards from
            popular brands across shopping, gaming, fashion, entertainment,
            footwear and more. Whether you are buying a gift for a friend,
            family member, colleague or client, a gift card gives the recipient
            the flexibility to choose something they actually want.
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.25rem", md: "1.25rem" },
              color: "#555",
              lineHeight: 1.8,
            }}
          >
            If you are looking for gift cards in the UAE, you can browse
            different categories and brands in one place. From shopping and
            fashion to gaming and entertainment, there are options for
            different interests, occasions and budgets.
          </Typography>
        </Box>

        {/* Section 2 */}
        <Box sx={{ mb: 5 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 700,
              color: "#0b2a5b",
              mb: 2,
            }}
          >
            Buy Gift Cards in the UAE
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.25rem", md: "1.25rem" },
              color: "#555",
              lineHeight: 1.8,
              mb: 2,
            }}
          >
            A gift card can be a simple option when you are not sure what to
            buy. Instead of choosing a specific product, you can select an
            available gift card and value based on your requirements.
          </Typography>

          <Typography
            sx={{
              color: "#555",
              lineHeight: 1.8,
              mb: 2,
              fontSize: { xs: "1.25rem", md: "1.25rem" },
            }}
          >
            99gift.ae brings different gift card options together so shoppers
            can compare available brands, values and offers before making a
            purchase. You can explore popular categories such as shopping,
            gaming, entertainment, fashion, footwear and more.
          </Typography>

          <Typography
            sx={{
              color: "#555",
              lineHeight: 1.8,
              fontSize: { xs: "1.25rem", md: "1.25rem" },
            }}
          >
            Whether you are searching for a gift card UAE, a gift for a special
            occasion or a convenient way to send a digital gift, you can browse
            the available options on 99gift.ae.
          </Typography>
        </Box>

        {/* Section 3 */}
        <Box sx={{ mb: 5 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem" },
              fontWeight: 700,
              color: "#0b2a5b",
              mb: 2,
            }}
          >
            Digital Gift Cards UAE
          </Typography>

          <Typography
            sx={{
              color: "#555",
              lineHeight: 1.8,
              mb: 2,
              fontSize: { xs: "1.25rem", md: "1.25rem" },
            }}
          >
            Digital gift cards in the UAE are a convenient alternative to
            traditional physical gifts. They can be suitable for birthdays,
            celebrations, rewards, employee recognition, customer gifting and
            many other occasions.
          </Typography>

          <Typography
            sx={{
              color: "#555",
              lineHeight: 1.8,
              mb: 2,
              fontSize: { xs: "1.25rem", md: "1.25rem" },
            }}
          >
            With digital gifting, you can choose from available brands and gift
            card values according to your needs. Popular choices may include
            shopping, gaming, entertainment, fashion and other lifestyle
            categories.
          </Typography>

          <Box
            sx={{
              backgroundColor: "#f7f7f7",
              borderLeft: "4px solid #1976d2",
              px: 3,
              py: 2,
              mt: 3,
            }}
          >
            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              Before purchasing, always check the product page for the specific
              gift card's value, availability, applicable region, redemption
              instructions and other terms.
            </Typography>
          </Box>
        </Box>

        {/* READ MORE CONTENT */}
        <Collapse in={expanded} timeout="auto">
          {/* Section 4 */}
          <Box sx={{ mb: 5 }}>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 700,
                color: "#0b2a5b",
                mb: 2,
              }}
            >
              Popular Gift Cards in UAE
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                mb: 2,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              Different people prefer different types of gifts. Shopping gift
              cards can be useful for someone who enjoys online shopping, while
              gaming gift cards can be a better choice for gamers. Entertainment
              and fashion gift cards can also work well for birthdays,
              celebrations and personal occasions.
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                mb: 2,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              On 99gift.ae, you can explore gift cards from popular brands and
              categories, including options for shopping, gaming, fashion,
              entertainment, footwear and more.
            </Typography>

            <Box
              sx={{
                backgroundColor: "#f7f7f7",
                borderLeft: "4px solid #1976d2",
                px: 3,
                py: 2,
                mt: 3,
              }}
            >
              <Typography
                sx={{
                  color: "#555",
                  lineHeight: 1.8,
                  fontSize: { xs: "1.25rem", md: "1.25rem" },
                }}
              >
                Some popular searches include{" "}
                <a
                  href="https://www.99gift.ae/card-details/amazon-incentive-uae-e-giftcard"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Amazon gift cards
                </a>
                ,{" "}
                <a
                  href="https://www.99gift.ae/card-details/noon-e-gift-card"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Noon gift cards
                </a>
                ,{" "}
                <a
                  href="https://www.99gift.ae/card-details/steam-uae"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Steam UAE
                </a>
                ,{" "}
                <a
                  href="https://www.99gift.ae/card-details/robux-1000-global"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  robux-1000-global
                </a>
                ,{" "}
                <a
                  href="https://www.99gift.ae/card-details/epic-games-store-uae"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#1976d2",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Fortnite gift cards
                </a>
                , subject to product availability.
              </Typography>
            </Box>
          </Box>

          {/* Section 5 */}
          <Box sx={{ mb: 5 }}>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 700,
                color: "#0b2a5b",
                mb: 2,
              }}
            >
              Best Gift Cards UAE for Different Occasions
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                mb: 2,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              A gift card can work for many occasions because the recipient can
              use it according to the applicable brand terms.
            </Typography>

            <Typography
              sx={{
                fontWeight: 600,
                color: "#333",
                mb: 1,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              You can explore gift ideas for:
            </Typography>

            <Box
              component="ul"
              sx={{
                color: "#555",
                lineHeight: 2,
                pl: 3,
                mb: 2,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              <li>Birthdays</li>
              <li>Anniversaries</li>
              <li>Eid</li>
              <li>Valentine's Day</li>
              <li>Graduation</li>
              <li>Thank-you gifts</li>
              <li>Employee rewards</li>
              <li>Client gifting</li>
              <li>Friends and family</li>
            </Box>

            <Box
              sx={{
                backgroundColor: "#f7f7f7",
                borderLeft: "4px solid #1976d2",
                px: 3,
                py: 2,
                mt: 3,
              }}
            >
              <Typography
                sx={{
                  color: "#555",
                  lineHeight: 1.8,
                  fontSize: { xs: "1.25rem", md: "1.25rem" },
                }}
              >
                If you are unsure which gift to choose, consider the recipient's
                interests first. A gaming gift card may suit a gamer, while a
                shopping or fashion gift card may be more suitable for someone
                who enjoys shopping.
              </Typography>
            </Box>
          </Box>

          {/* Section 6 */}
          <Box sx={{ mb: 5 }}>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 700,
                color: "#0b2a5b",
                mb: 2,
              }}
            >
              UAE Gift Card Options for Every Budget
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                mb: 2,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              Gift card values can vary depending on the brand and product.
              Before ordering, check the available denominations on the
              relevant product page and select the option that fits your budget.
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              For personal gifting, you can choose a value based on the
              occasion and your relationship with the recipient. For
              businesses, gift cards can also be considered for employee
              rewards, customer appreciation and corporate gifting programs.
            </Typography>
          </Box>

          {/* Section 7 */}
          <Box sx={{ mb: 5 }}>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 700,
                color: "#0b2a5b",
                mb: 2,
              }}
            >
              Why Choose 99gift.ae?
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
                mb: 2,
              }}
            >
              99gift.ae brings gift card options together in one UAE-focused
              shopping experience. You can browse by brand or category, check
              available values and review the relevant product information
              before placing an order.
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
                mb: 2,
              }}
            >
              The platform includes gift card options across categories such as
              shopping, gaming, entertainment, fashion and footwear, making it
              easier to find a suitable gift for different people and
              occasions.
            </Typography>

            <Box
              sx={{
                backgroundColor: "#f7f7f7",
                borderLeft: "4px solid #1976d2",
                px: 3,
                py: 2,
                mt: 3,
              }}
            >
              <Typography
                sx={{
                  color: "#555",
                  lineHeight: 1.8,
                  fontSize: { xs: "1.25rem", md: "1.25rem" },
                }}
              >
                Whether you are searching for a digital gift card UAE, an
                online gift card UAE, or a gift voucher UAE, browse the
                available options and choose the product that best matches
                your requirements.
              </Typography>
            </Box>
          </Box>

          {/* Final Section */}
          <Box
            sx={{
              mb: 3,
              pt: 2,
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "1.5rem", md: "2rem" },
                fontWeight: 700,
                color: "#0b2a5b",
                mb: 2,
              }}
            >
              Find Your Gift Card in the UAE
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                mb: 2,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              The right gift does not have to be difficult to find. Explore
              available gift cards on 99gift.ae, discover popular brands and
              categories, and choose a gift card based on the recipient,
              occasion and value you need.
            </Typography>

            <Typography
              sx={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: { xs: "1.25rem", md: "1.25rem" },
              }}
            >
              Browse gift cards and find a suitable digital gift for your next
              occasion.
            </Typography>
          </Box>
        </Collapse>

        {/* Read More / Show Less Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            pb: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
            sx={{
              color: "#0b2a5b",
              borderColor: "#0b2a5b",
              px: 4,
              py: 1,
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 600,
              borderRadius: 2,
              minWidth: 140,
              "&:hover": {
                borderColor: "#0b2a5b",
                backgroundColor: "#f5f8fc",
              },
            }}
          >
            {expanded ? "Show Less" : "Read More"}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default CompanyPortfolio;
